import type { AvailabilityInfo } from '../../constants/props';
import formatDateAndMonth from '../formatDateAndMonth';

enum DaysRange {
  SameDayDelivery,
  UnderFourDays,
  Tomorrow,
  OverFourDays,
  Unknown
}

function getDaysRange(daysUntilDeliveryOrPickup: number) {
  if (daysUntilDeliveryOrPickup < 1) return DaysRange.SameDayDelivery;
  if (daysUntilDeliveryOrPickup === 1) return DaysRange.Tomorrow;
  if (daysUntilDeliveryOrPickup > 1 && daysUntilDeliveryOrPickup <= 4)
    return DaysRange.UnderFourDays;
  if (daysUntilDeliveryOrPickup > 4) return DaysRange.OverFourDays;

  return DaysRange.Unknown;
}

type GetItBy = {
  activityType?: string;
  getItBy: string;
  routeId?: string;
  utcSoonestDateTimeIso: string;
};

export default function calculateGetItBy(
  {
    activityType,
    asSoonAsText,
    daysToAvailability,
    routeId,
    utcSoonestDateTimeIso
  }: Partial<AvailabilityInfo>,
  truncateDay: boolean = true,
  truncateMonth: boolean = true
): GetItBy {
  if (!utcSoonestDateTimeIso || daysToAvailability === undefined) {
    return {
      activityType: '',
      getItBy: '',
      routeId: '',
      utcSoonestDateTimeIso: ''
    };
  }

  const chipTextMap = {
    [DaysRange.SameDayDelivery]: 'Today',
    [DaysRange.UnderFourDays]: asSoonAsText,
    [DaysRange.Tomorrow]: 'Tomorrow',
    [DaysRange.OverFourDays]: formatDateAndMonth(
      utcSoonestDateTimeIso,
      truncateDay,
      truncateMonth
    ),
    [DaysRange.Unknown]: ''
  };

  return {
    activityType,
    getItBy: chipTextMap[getDaysRange(daysToAvailability)] ?? '',
    routeId,
    utcSoonestDateTimeIso
  };
}
